var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "scurity"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29303",
    "data-name": "Rectangle 29303",
    width: 18,
    height: 18,
    transform: "translate(281 377)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_697",
    "data-name": "Mask Group 697",
    transform: "translate(-281 -377)",
    clipPath: "url(#scurity)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_13_",
    "data-name": "svgexport-7 (13)",
    transform: "translate(281 377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11646",
    "data-name": "Group 11646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11645",
    "data-name": "Group 11645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11644",
    "data-name": "Group 11644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11681",
    "data-name": "Path 11681",
    d: "M8.114,12.456l-.237,2.127A.375.375,0,0,0,8.25,15h1.5a.375.375,0,0,0,.373-.416l-.237-2.127A1.484,1.484,0,0,0,10.5,11.25a1.5,1.5,0,0,0-3,0A1.484,1.484,0,0,0,8.114,12.456ZM9,10.5a.747.747,0,0,1,.324,1.422.375.375,0,0,0-.209.379l.217,1.949H8.669L8.886,12.3a.375.375,0,0,0-.209-.379A.747.747,0,0,1,9,10.5Z",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11682",
    "data-name": "Path 11682",
    d: "M15.375,6.75H14.25V5.25a5.25,5.25,0,0,0-10.5,0v1.5H2.625a.375.375,0,0,0-.375.375V16.5A1.5,1.5,0,0,0,3.75,18h10.5a1.5,1.5,0,0,0,1.5-1.5V7.125A.375.375,0,0,0,15.375,6.75ZM4.5,5.25a4.5,4.5,0,1,1,9,0v1.5h-.75V5.25a3.75,3.75,0,0,0-7.5,0v1.5H4.5Zm7.5,0v1.5H6V5.25a3,3,0,0,1,6,0ZM15,16.5a.751.751,0,0,1-.75.75H3.75A.751.751,0,0,1,3,16.5v-9H15Z",
    fill: "#6a6f73"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8510cbc70b8b12addfd3afed81bb7ed7.svg";
export { ForwardRef as ReactComponent };